import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchOrgs(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/sites', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchOrg(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/sites/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addOrg(ctx, org) {
      return new Promise((resolve, reject) => {
        axios
          .post('/sites', org)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateOrg(ctx, org) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/sites/${org.id}`, org)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteOrg(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/sites/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchExportOrgs() {
      return new Promise((resolve, reject) => {
        axios
          .get('/sites/export')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
